import { render } from "./LoginForm.vue?vue&type=template&id=3dcc16e7"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"
script.render = render

export default script